const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();

const decodeBase64 = (value) => {
  const binary = atob(value);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};

const encodeBase64 = (bytes) => {
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary);
};

class BufferPolyfill extends Uint8Array {
  static from(input, encoding = 'utf8') {
    if (typeof input === 'string') {
      if (encoding === 'base64') return new BufferPolyfill(decodeBase64(input));
      return new BufferPolyfill(textEncoder.encode(input));
    }
    if (ArrayBuffer.isView(input) || input instanceof ArrayBuffer) {
      return new BufferPolyfill(input);
    }
    if (Array.isArray(input)) {
      return new BufferPolyfill(input);
    }
    return new BufferPolyfill([]);
  }

  toString(encoding = 'utf8') {
    if (encoding === 'base64') return encodeBase64(this);
    return textDecoder.decode(this);
  }
}

if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = BufferPolyfill;
}
